// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3eEDf","inputDescription":"styles_inputDescription__1zABf"};